module.exports = __webpack_public_path__ + "img/icon-mail-gray.430f9c89.svg";